import { framework, rules } from '@buzzfeed/consent';
import { manageHEMCookie } from '@buzzfeed/bf-utils';

export const addHemCookie = async (email) => {
  let isConsentReady = false;
  let consentValue = false;
  const needsConsent = framework.needsConsent();
  if (!needsConsent) {
    isConsentReady = true;
    consentValue = true;
  } else {
    consentValue = await rules.hasConsented('tracking');
    isConsentReady = true;
  }
  manageHEMCookie({
    email,
    isConsentReady,
    consentValue
  });
};
